import axios from 'axios'
import {CookiesService} from './Cookie.service'

/**
 * Instância axios do módulo Ata Inteligente (carona-service, FastAPI).
 *
 * Anexa SEMPRE o Bearer do core — igual às outras instâncias (analyzer,
 * price-research, levantamento). Sem o header, toda rota autenticada do
 * carona-service responde 401 fora do ambiente de dev.
 *
 * Truque do ambiente local: o bypass de dev do backend aceita a requisição sem
 * token OU com token == DEV_AUTH_KEY. Como aqui o header vai sempre, para rodar
 * local sem subir o core basta pôr VITE_CARONA_TOKEN=<DEV_AUTH_KEY> no
 * .env.local: o override entra como Bearer e o bypass aceita, COM header.
 *
 * TRAVA: o override só é lido quando import.meta.env.DEV é true. No build de
 * produção o Vite substitui DEV por `false`, o ramo morre no tree-shaking e
 * VITE_CARONA_TOKEN não chega ao bundle publicado — nem por engano de .env.
 */
const MyAxiosInstanceCarona = axios.create({
    baseURL: import.meta.env.VITE_CARONA_URL,
})

const cookies = new CookiesService()

MyAxiosInstanceCarona.interceptors.request.use(
    (config) => {
        const override = import.meta.env.DEV
            ? import.meta.env.VITE_CARONA_TOKEN
            : undefined
        config.headers.Authorization = override
            ? `Bearer ${override}`
            : `Bearer ${cookies.getAuthData()?.access_token}`
        return config
    },
    (error) => Promise.reject(error)
)

export default MyAxiosInstanceCarona
